import css from "styled-jsx/css";
import Colors from "/styles/colors";
import { MOBILE_QUERY_MAX_WIDTH } from "constants/vp-sizes";

export const componentStyles = css.global`
  .bullets {
    display: flex;
    flex-wrap: wrap;

    .bullet {
      display: flex;
      align-items: flex-start;

      .bullet-icon {
        height: 16px;
        width: 16px;
        padding-top: 10px;

        svg {
          height: 16px;
          width: 16px;
          circle {
            fill: ${Colors["brand-turqoise"]};
          }
        }
      }

      .bullet-text {
        margin-left: 8px;
        font-size: 18px;
        line-height: 31px;
        padding-right: 24px;
      }
    }

    @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
      .bullet {
        width: 100%;
      }
    }
  }
`;
